import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import axios from '../../axios-signup';
import {CardElement, injectStripe, StripeProvider, Elements} from 'react-stripe-elements';
import Error from '../../components/UI/Error';
import './Billing.css';
import wrapper from "../../hoc/wrapper";
import Header from "../../components/Header/Header";
import { Loader } from 'react-overlay-loader';

class Billing extends Component {
    render() {
        let stripe_key = process.env.REACT_APP_STRIPE_PK;
        return (
            <StripeProvider apiKey={stripe_key}>
                <div>
                    <Elements>
                        <CardForm emailAddress={this.props.location.state.emailAddress}/>
                    </Elements>
                </div>
            </StripeProvider>
        )
    }
}


class _CardForm extends Component {
    state = {
        emailAddress: this.props.emailAddress,
        stripeToken: '',
        billingEmail: '',
        billingContact: '',
        errorMsg: '',
        submitted: false,
        unauthorized: false,
        loading: false
    };

    handleSubmit = (event, stripe) => {
        event.preventDefault();
        this.setState({loading: true});
        stripe.createToken().then(
            result => {
                if (result.error) {
                    this.setState({errorMsg: result.error.message, loading: false})
                } else {
                    this.stripeTokenHandler(result.token)
                }
            }
        )
    };

    stripeTokenHandler = (token) => {
        this.setState({stripeToken: token.id});

        axios.post("/credit-card", {
            emailAddress: this.state.emailAddress,
            billingEmail: this.state.billingEmail,
            billingContact: this.state.billingContact,
            stripeToken: this.state.stripeToken
        }).then(res => {
            this.setState({submitted: true, loading: false})
        }).catch(err => {
            if (err.response.status === 401) {
                this.setState({unauthorized: true, loading: false})
            } else {
                this.setState({errorMsg: err.response.data.error, loading: false});
            }
        })

    };

    handleChange = (event, input) => {
        this.setState({[input]: event.target.value});
    };

    handleSkip = () => {
        this.setState({loading: true});
        axios.post("/credit-card", {
            emailAddress: this.state.emailAddress,
            billingEmail: '',
            billingContact: '',
            stripeToken: ''
        }).then(res => {
            this.setState({submitted: true, loading: false})
        }).catch(err => {
            if (err.response.status === 401) {
                this.setState({unauthorized: true, loading: false})
            } else {
                this.setState({errorMsg: err.response.data.error, loading: false});
            }
        })
    };

    handleKeyPress = (event, stripe) => {
        if(event.key === 'Enter'){
            this.setState({loading: true});
            stripe.createToken().then(
                result => {
                    if (result.error) {
                        this.setState({errorMsg: result.error.message, loading: false})
                    } else {
                        this.stripeTokenHandler(result.token)
                    }
                }
            )
        }
    };

    render() {
        let redirect = null;

        if (this.state.submitted) {
            redirect = <Redirect to={{pathname: "/signup/aws-account", state: {emailAddress: this.state.emailAddress}}}/>
        } else if (this.state.unauthorized) {
            redirect = <Redirect to="/signup/"/>
        }

        const style = {
            base: {
                color: '#32325d',
                lineHeight: '20px',
                fontFamily: 'Arial',
                fontSmoothing: 'antialiased',
                fontSize: '18px',
                '::placeholder': {
                    color: '#bbbbbb'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        return (
            <div>
                <Header currentWizard="5"/>
            <main role="main">
                <Loader fullPage={true} loading={this.state.loading}/>
                <section className="section yellow">
                    {redirect}
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-7 col-md-8 col-center text-center">
                                <h1 className="black"><strong>Billing Information</strong></h1>
                                <h5 className="gray mb-4"><strong>Please enter your billing information below.<br/>
                                    You will not be charged until after your 14-day free trial ends.</strong></h5>
                                <Error errorMsg={this.state.errorMsg} divClass="col-md-8 col-center"/>
                                <div className="row">
                                    <div className="col-md-8 col-center">
                                        <div className="form-group">
                                            <CardElement style={style}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" placeholder="Billing Contact"
                                                   className="form-control"
                                                   onChange={(e) => this.handleChange(e, 'billingContact')} onKeyPress={e => this.handleKeyPress(e, this.props.stripe)}/>
                                        </div>
                                        <div className="form-group">
                                            <input type="text" placeholder="Billing Email"
                                                   className="form-control"
                                                   onChange={(e) => this.handleChange(e, 'billingEmail')} onKeyPress={e => this.handleKeyPress(e, this.props.stripe)}/>
                                        </div>
                                        <div className="form-group mt-4">
                                            <input type="submit" value="Submit" className="btn btn-primary"
                                                   onClick={e => this.handleSubmit(e, this.props.stripe)}/>
                                            <input type="submit" value="Skip for now" className="btn btn-link" onClick={this.handleSkip}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            </div>
        )
    }
}

const CardForm = injectStripe(_CardForm);

export default wrapper(Billing);
